// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const HrWorkspacePage = () => import('@/modules/hr/views/HrWorkspacePage')
const RecruitmentTab  = () => import('@/modules/hr/views/RecruitmentTab')
const OnboardingTab  = () => import('@/modules/hr/views/OnboardingTab')
const EmployeeTab  = () => import('@/modules/hr/views/EmployeeTab')
const OffboardingTab  = () => import('@/modules/hr/views/OffboardingTab')
const IncidentsTab  = () => import('@/modules/hr/views/IncidentsTab')
const TerminatedTab  = () => import('@/modules/hr/views/TerminatedTab')
const LeaveOfAbsenceTab  = () => import('@/modules/hr/views/LeaveOfAbsenceTab')
const NotHiringTab  = () => import('@/modules/hr/views/NotHiringTab')

var routes = [
    {
        path: '/hr',
        redirect: '/hr/employees',
        name: 'HrWorkspace',
        component: DefaultContainer,
        children: [
            {
				path: '/hr',
                name: 'HrWorkspacePage',
				redirect: '/hr/recruitment',
                component: HrWorkspacePage,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
				children: [
					{
						path: 'recruitment',
						name: 'RecruitmentTab',
						component: RecruitmentTab,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'recruitment',
						},
					},
                    {
						path: 'onboarding',
						name: 'OnboardingTab',
						component: OnboardingTab,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'onboarding',
						},
					},
                    {
						path: 'employee',
						name: 'EmployeeTab',
						component: EmployeeTab,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'employee',
						},
					},
                    {
						path: 'offboarding',
						name: 'OffboardingTab',
						component: OffboardingTab,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'offboarding',
						},
					},
					{
						path: 'incidents',
						name: 'IncidentsTab',
						component: IncidentsTab,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'incidents',
						},
					},
					{
						path: 'terminated',
						name: 'TerminatedTab',
						component: TerminatedTab,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'terminated',
						},
					},
					{
						path: 'leave-of-absence',
						name: 'leaveOfAbsenceTab',
						component: LeaveOfAbsenceTab,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'leaveOfAbsence',
						},
					},
					{
						path: 'not-hiring',
						name: 'notHiringTab',
						component: NotHiringTab,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'notHiring',
						},
					},
				]
            },
        ]
    },
];

export default routes;
